import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReservationsReportFilterForm } from 'src/app/shared/interfaces';

import { DataWithPagination } from '../../interface';
import { ReservationsReportApi } from '../api/reservations-report-api';
import { ReservationsReport } from '../model';
import { Repository } from './repository';

@Injectable({
  providedIn: 'root',
})
export class ReservationsReportRepository extends Repository {
  constructor(private reservationsReportApi: ReservationsReportApi) {
    super();
  }

  getReservationsReport(filter: ReservationsReportFilterForm): Observable<DataWithPagination<ReservationsReport[]>> {
    return this.reservationsReportApi.getReservationsReport(filter);
  }
}
